import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { HttpService, NotificationService, TmsWebBaseEditService } from 'tms-lib';
import { ShippingRegionHeader } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ShippingRegionHeaderService extends TmsWebBaseEditService<ShippingRegionHeader, ShippingRegionHeader> {
  public refreshDetails = new Subject<void>();

  constructor(
    protected httpService: HttpService,
    protected notificationService: NotificationService,
  ) {
    super('ShippingRegionHeader', $localize`Shipping Region Header`, httpService, notificationService);
  }
}
